import { render, staticRenderFns } from "./BandwidthPolicies.vue?vue&type=template&id=59c9c2f6&scoped=true"
import script from "./BandwidthPolicies.vue?vue&type=script&lang=js"
export * from "./BandwidthPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c9c2f6",
  null
  
)

export default component.exports